import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import "./NewOrderModal.css"
import { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus  } from "@fortawesome/free-solid-svg-icons";
import NewCustomerModal from '../NewUserModal/NewCustomerModal';
import NewModelModal from '../NewModelModal/NewModelModal';
import NewSerialModal from '../NewSerialModal/NewSerialModal';



//LOG FUNCTION
import { storeOrderLog } from "../../Helper_Library.js";

const NewOrderModal = ({ show, requestClose }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const servicesURL = process.env.REACT_APP_SERVICES_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //INPUTS CONTROLS
    const [customer, setCustomer] = useState(null);
    const [customerID, setCustomerID] = useState(null);
    const [model, setModel] = useState(null);
    const [serialNumber, setSerialNumber] = useState(null);
    const [failure, setFailure] = useState(null);
    const [personContact, setPersonContact] = useState(null);
    const [personContactData, setPersonContactData] = useState(null);
    const [address, setAddress] = useState(null);
    const [customersCombo, setCustomersCombo] = useState([]);
    const [notes, setNotes] = useState(null);


    //ADD NEW USER MODAL CONTROLLER
    const [showModal_AddUser, setShowModal_AddUser] = useState(false);   
    const requestCloseModal_AddUser = () => { setShowModal_AddUser(false); getUsersListing(); }
    const openModal_AddUser = () => { setShowModal_AddUser(true); }
    
    //
    const options = customersCombo
        .filter(item => item.groupname === "Clientes")
        .filter(item => item.is_active == 1)
        .map(item => ({
            value: item.id,
            label: item.customer_name
    }));

    const [options_model, setOptionsModel] = useState([]);
    const [options_serials, setOptionsSerials] = useState([]);


    //ADD NEW MODEL MODAL
    const [showModal_AddModel, setShowModal_AddModel] = useState(false);   
    const requestCloseModal_AddModel = () => { 
        
        getModelsByCustomer();

        setShowModal_AddModel(false); 
    
    } //END

    const openModal_AddModel = () => { 
    
        if(!customerID) {


            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Debe seleccionar un cliente para poder agregar modelos.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }
        
        setShowModal_AddModel(true); 
    
    }//END

    //ADD NEW SERIAL MODAL
    const [showModal_AddSerial, setShowModal_AddSerial] = useState(false);   
    const requestCloseModal_AddSerial = () => { 
        
        getSerialsByModel();

        setShowModal_AddSerial(false); 
    
    } //END

    const openModal_AddSerial = () => { 
    
        if(!customerID) {


            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Debe seleccionar un cliente para poder agregar seriales.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }

        setShowModal_AddSerial(true); 
    
    } //END

    
    useEffect(() => {

        if(customerID){
            getModelsByCustomer();
        }

    }, [customer]);


    //
    useEffect(() => {

        getSerialsByModel();

    }, [model]);


     //
    useEffect(() => {

        //
        let tempCustomerID = customersCombo.find(item => item.customer_name === customer) ?.id;
        setCustomerID(tempCustomerID);
        
    }, [customersCombo]);

     //
    useEffect(() => {

        getModelsByCustomer();

    }, [customerID]);


    

    const getUsersListing = async () =>{

        const endpoint = "getUsersListing";
        
        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        const responseContent = await response.json();

        setCustomersCombo(responseContent);


    } //END FUNCTION

    function getCurrentDateTimeInArgentina() {

        const now = new Date();
        const argentinaTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' }));

        const year = argentinaTime.getFullYear();
        const month = String(argentinaTime.getMonth() + 1).padStart(2, '0');
        const day = String(argentinaTime.getDate()).padStart(2, '0');
        const hours = String(argentinaTime.getHours()).padStart(2, '0');
        const minutes = String(argentinaTime.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}`;

    }//

    const addNewOrder = async () => {

        //MAIN VALIDATION
        if(!customer || !model || !serialNumber || !failure || !personContact || !address) {

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Faltan datos obligatorios por completar.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//

       

        //DATOS MINIMOS
        if(serialNumber.label.length < 4) { 

            //Show message sweet alert
            Swal.fire({
                title: "Datos Mínimos",
                text: "El campo Nro de Serie debe tener mínimo 4 caracteres.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;

        }


        //
        const metadata = {
            "customer":customer,
            "model":model.label.replace(/[\t\\']/g, ''),
            "serialNumber":serialNumber.label.replace(/[\t\\']/g, ''),
            "failure":failure.replace(/[\t\\']/g, ''),
            "personContact":personContact.replace(/[\t\\']/g, ''),
            "issuesDate": getCurrentDateTimeInArgentina(),
            "status": "Por asignar técnico",
            "tecnico": "---",
            "address": address ? address.replace(/[\t\\']/g, '') : "",
            "personContactData": personContactData ? personContactData.replace(/[\t\\']/g, '') : "",
            "notes": notes ? notes.replace(/[\t\\']/g, '') : ""
        };

        //
        const requestBody ="{\"metadata\":\"" + JSON.stringify(metadata).replace(/"/g, '\\"') + "\"}";
        
        const endpoint = "addOrder";

        const response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
            body: requestBody
        });

        const responseContent = await response.json();

        //STORE LOG INFORMATION
        storeOrderLog(responseContent.order_id, sessionUser.customer_name, "Creación del Servicio", "En espera de asignación de técnico.");

        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Operación realizada exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });


        //CLOSE MODAL
        requestClose(false);

    } //

    const onModalShow = () => {

        //GET USER SESSION
        if(sessionUser.groupname === "Clientes") { 
            
            getUsersListing(); 
            
            setCustomer(sessionUser.customer_name); 

            //CLEAR FIELDS
            setModel("");
            setSerialNumber("");
            setFailure("");
            setPersonContact("");
            setAddress("");
            setNotes("");
        
        
        }
        else { 
            
            getUsersListing(); 

              //CLEAR FIELDS
            setCustomer("");
            setModel("");
            setSerialNumber("");
            setFailure("");
            setPersonContact("");
            setAddress("");
            setNotes("");
        
        
        }

    } //END FUNCTION


    const getModelsByCustomer = async () => {


        if(customerID){
            
            const endpoint = "getModels?clienteId=" + customerID;
            console.log(servicesURL + endpoint);

            const response = await fetch(servicesURL + endpoint,
            {
                method: "GET",
                headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
            });

            const responseContent = await response.json();

            let optionItems = [];

            let counter = 1;
            responseContent.forEach((item)=>{

                let node = {
                    value: counter,
                    label: item
                }

                optionItems.push(node);

                counter++;
            });
            

            setModel(null);
            setSerialNumber(null);
            setOptionsSerials([]);
            setOptionsModel(optionItems);

        } //END IF


    } //END FUNCTION


    const getSerialsByModel = async () => {


       if(model){

  
            const endpoint = "getserials?clienteId=" + customerID + "&modelo=" + model.label;
            console.log(servicesURL + endpoint);

            const response = await fetch(servicesURL + endpoint,
            {
                method: "GET",
                headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
            });

            const responseContent = await response.json();

            console.log(responseContent);

            let optionItems = [];

            let counter = 1;
            responseContent.forEach((item)=>{

                let node = {
                    value: counter,
                    label: item.serial,
                    location: item.ubicacion
                }

                optionItems.push(node);

                counter++;
            });

            setSerialNumber(null);
            setOptionsSerials(optionItems);

        } //END IF
        

    } //END FUNCTION

    

    return (
        <>
        <Modal show={show} onShow={onModalShow} onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Agregar Orden de Servicio</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row>
                    <Col xs={12}>
                        <Form.Group>
                            <Form.Label className={'newOrderlabels'}>Cliente</Form.Label>
                            { sessionUser.groupname === "Clientes" ? (
                                 <Form.Control 
                                    type="text" 
                                    value={sessionUser.customer_name} 
                                    disabled="disabled"
                                    
                                    />
                                 ) : (
                                    <>  
                                    <Row>
                                        <Col xs={11}>
                                            <Select 
                                                style={{fontSize:"14px"}}
                                                options={options}
                                                onChange={(selectedOption) => { setCustomer(selectedOption.label); setCustomerID(selectedOption.value); }}
                                                >
                                            </Select>
                                        </Col>
                                        <Col xs={1} style={{textAlign:"center", paddingTop: "5px", cursor:"pointer"}}>
                                            <FontAwesomeIcon 
                                            icon={faCirclePlus} 
                                            style={{fontSize: "20px"}} 
                                            onClick = {openModal_AddUser}
                                            />
                                        </Col>
                                    </Row>
                                    </>
                                )
                            }
                            <br />
                        </Form.Group>
                    </Col>
                    <Col xs={6}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Modelo</Form.Label>
                             <Select 
                                style={{fontSize:"14px"}}
                                options={options_model}
                                value={model}
                                placeholder="-- Selecciona un Modelo --"
                                onChange={(selectedOption) => { setModel(selectedOption); }}
                                >
                            </Select>
                            <Button 
                                size='sm' 
                                variant="outline-info" 
                                style={{color:"#666666", fontSize: "10px", marginTop: "5px"}}
                                onClick = {openModal_AddModel}
                                >
                                ➕ Modelo
                            </Button>
                            <br /><br />

                        </Form.Group>
                    </Col>
                    <Col xs={6}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>N° de Serie</Form.Label>
                             <Select 
                                style={{fontSize:"14px"}}
                                options={options_serials}
                                value={serialNumber}
                                onChange={(selectedOption) => {setSerialNumber(selectedOption); setAddress(selectedOption.location); } }
                                placeholder="-- Selecciona un serial --"
                                >
                            </Select>
                            <Button 
                                size='sm' 
                                variant="outline-info" 
                                style={{color:"#666666", fontSize: "10px", marginTop: "5px"}} 
                                onClick = {openModal_AddSerial}
                                >
                                ➕ Serial
                            </Button>
                            <br /> <br />

                        </Form.Group>
                    </Col>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Falla / Detalles</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Falla del equipo" 
                             maxLength={200} 
                             onChange={(event)=> setFailure(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Persona Contacto</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Nombre y apellido del solicitante..." 
                             maxLength={80} 
                             onChange={(event)=> setPersonContact(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Datos del Contacto</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Teléfono / Email" 
                             maxLength={80} 
                             onChange={(event)=> setPersonContactData(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Dirección del Servicio</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Direccion..." 
                             maxLength={200} 
                             value={address}
                             onChange={(event)=> setAddress(event.target.value)} /><br />
                        </Form.Group>
                    </Col>
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Notas / Observaciones</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Notas varias" 
                             maxLength={200} 
                             onChange={(event)=> setNotes(event.target.value)} /><br />
                        </Form.Group>
                    </Col>
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={addNewOrder}
                >

                Guardar Datos
            </Button>
            </Modal.Footer>
        </Modal>

        {/* MODAL ADD USER COMPONENT */}
        <NewCustomerModal show={showModal_AddUser} requestClose={requestCloseModal_AddUser}/>

        {/* MODAL */}
        <NewModelModal show={showModal_AddModel} requestClose={requestCloseModal_AddModel} selectedClientID={customerID} />

        {/* MODAL */}
        <NewSerialModal show={showModal_AddSerial} requestClose={requestCloseModal_AddSerial} selectedClientID={customerID}/>

        </>
    );
}

export default NewOrderModal;